import siteData from "./site-data"

const social = [
    {
        icon: "mail-solid",
        url: `mailto:${siteData.email}`,
    },
    {
        icon: "github-brand",
        url: siteData.github,
    },
    {
        icon: "figma-brand",
        url: siteData.figma,
    },
    {
        icon: "npm-brand",
        url: siteData.urlNpm,
    },
]

export default social
